import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigation, X } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { setShowGpsBanner, scheduleGpsRetry } from '../../store/slices/locationSlice';
import useLocationCheck from '../../hooks/useLocationCheck';
import './GpsBanner.css';

/**
 * Banner sticky persistant affiché quand localisation IP temporaire est utilisée
 * Incite l'utilisateur à activer le GPS pour plus de précision
 */
const GpsBanner = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { retryGPS } = useLocationCheck();
  const strategy = useSelector(state => state.location.strategy);

  /**
   * Handler pour activer le GPS
   */
  const handleActivateGPS = () => {
    retryGPS();
  };

  /**
   * Handler pour fermer le banner (temporairement)
   * Le banner réapparaîtra après 5 minutes
   */
  const handleDismiss = () => {
    dispatch(setShowGpsBanner(false));
    // Programmer la réapparition du banner après 5 minutes
    dispatch(scheduleGpsRetry());
  };

  // Calculer la précision approximative pour affichage
  const accuracyKm = strategy.accuracy ? Math.round(strategy.accuracy / 1000) : 10;

  return (
    <div className="gps-banner">
      <div className="gps-banner-content">
        {/* Icône GPS animée */}
        <div className="gps-banner-icon">
          <Navigation size={24} className="gps-icon-animated" />
        </div>

        {/* Texte */}
        <div className="gps-banner-text">
          <h4 className="gps-banner-title">{t('location.banner.title')}</h4>
          <p className="gps-banner-description">
            {t('location.banner.description', { distance: accuracyKm })}
          </p>
        </div>

        {/* Actions */}
        <div className="gps-banner-actions">
          <button
            onClick={handleActivateGPS}
            className="btn-activate-gps"
            type="button"
          >
            {t('location.banner.activate')}
          </button>

          <button
            onClick={handleDismiss}
            className="btn-dismiss-banner"
            type="button"
            aria-label={t('location.banner.dismiss')}
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GpsBanner;
